import { useAccount } from 'wagmi';

export const useIsWrongNetwork = ({ expectedChainId }: { expectedChainId: number }) => {
  const { chainId: walletChainId, address: account } = useAccount();

  const isWrong = !!account && expectedChainId !== walletChainId;

  return isWrong;
};
